import { useSuspenseQuery } from '@tanstack/react-query';
import { graphql } from '@/generated/gql/gql';
import { GetMeQuery } from '@/generated/gql/graphql';
import { gqlClient } from '@/lib/gqlClient';

const GET_ME = graphql(`
  query GetMe {
    me {
      account {
        name
        newExperienceEnabled
        segment
        id
        srm {
          calendarLink
          center
          emailAddress
          fallback
          firstName
          isCalendlyEnabled
          lastName
          phoneNumber
          team
        }
      }
      created
      divisions {
        accountId
        srm {
          team
        }
      }
      emailAddress
      formatPreferences {
        aggregateCurrencyFormat
        dateDisplayFormat
        numberDisplayFormat
        useCustomFormatting
      }
      intercomUserId
      loginHistory(limit: 2) {
        created
      }
      personalInfo {
        address {
          country
          postalCode
        }
        arDepartmentEmailAddress
        firstName
        fiscalYearEnd
        industry
        lastName
        locale
        primaryPhoneNumber
        role
        secondaryPhoneNumber
      }
      supplierReadOnly
    }
  }
`);

export async function fetchUserDetails(): Promise<GetMeQuery> {
  return gqlClient.request(GET_ME);
}

/**
 * Fetches the user details for the currently logged-in user.
 */
export default function useUserDetails<TData = GetMeQuery>(select?: (data: GetMeQuery) => TData) {
  return useSuspenseQuery({
    queryKey: ['user-details'],
    queryFn: fetchUserDetails,
    select,
  });
}
